<template>
    <div class="chart-container">
        <div class="values-container">
            <div class="current-value">
                <div class="label">
                    {{ model.title }}
                </div>
                <div class="lga-value">
                    {{ model.formatValue(model.value) }}
                </div>
            </div>
            <div class="comparison-value">
                <div class="compare-value">
                    {{ model.formatValue(model.comparisonValue) }}
                </div>
                <div class="compare-value">
                    in {{ model.comparisonLabel }}
                </div>
            </div>
        </div>
        <div class="growth-container">
            <div class="values">
                <div class="label">
                    {{ model.growthLabel }}
                </div>
                <div class="lga-value">
                    {{ model.formatPct(model.growth) }}<span class="lga-units">{{ model.growthUnits }}</span>
                </div>
                <div class="compare-value">
                    {{ model.formatPct(model.comparisonGrowth) }}{{ model.growthUnits }} in {{ model.comparisonLabel }}
                </div>
            </div>
            <div class="line-chart-container">
                <dynamic-resize-container
                    class="population-growth"
                >
                    <template #default="{width}">
                        <line-chart
                            v-if="width > 0"
                            class="line-chart"
                            :width="width"
                            :height="80"
                            :values="[model.allComparisonGrowthValues, model.allGrowthValues]"
                            x-prop="year"
                            y-prop="growthValue"
                        >
                            <template #tooltip-content="{ value: { year }, index }">
                                <div>
                                    <div class="tooltip-title">
                                        Population in {{ year }}
                                    </div>
                                    <div class="tooltip-label">
                                        {{ model.valueLabel }}
                                    </div>
                                    <div class="tooltip-value">
                                        {{ model.formatValue(model.allGrowthValues[index].value) }}
                                    </div>
                                    <div class="tooltip-compare-value">
                                        {{ model.formatValue(model.allComparisonGrowthValues[index].value) }} in {{ model.comparisonLabel }}
                                    </div>
                                </div>
                            </template>
                            <!--
                            <template
                                #tooltip-content
                            >
                                <div>
                                    <div class="tooltip-label">
                                        {{ model.valueLabel }}
                                    </div>
                                    <div class="tooltip-value">
                                        {{ model.formatWithUnits(model.value) }}
                                    </div>
                                    <div class="tooltip-compare-value">
                                        {{ model.formatWithUnits(model.comparisonValue) }} in {{ model.comparisonLabel }}
                                    </div>
                                </div>
                            </template> -->
                        </line-chart>
                    </template>
                </dynamic-resize-container>
            </div>
        </div>
        <info-tooltip
            :definition="model.definition"
            :link-to-health="model.linkToHealth"
            :data-source="model.dataSource"
        />
    </div>
</template>

<script>
import DynamicResizeContainer from '@/components/DynamicResizeContainer.vue';
import LineChart from '@/components/LineChart.vue';
import InfoTooltip from '@/components/InfoTooltip.vue';

export default {
    components: {
        DynamicResizeContainer, LineChart, InfoTooltip
    },
    props: {
        model: {
            type: Object,
            required: true
        }
    }
};
</script>

<style src="./common.container.css" scoped></style>
<style lang="postcss" scoped>
.pdf .resize-container.population-growth {
    min-width: 250px;
    max-width: 250px;
}

div.chart-container {
    @apply justify-between items-center;
}

div.values-container {
    @apply flex flex-row justify-between items-end mb-12;
}

div.growth-container {
    @apply flex flex-row justify-between items-end;
}

div.line-chart-container {
    @apply relative flex-grow;
}

div.comparison-value {
    @apply text-right;
}

div.line-chart {
    @apply flex-grow-0;
}

div.values {
    @apply mr-8;
}


.tooltip:not(.tooltip-lga) {
    @apply text-neutral-text;
}
.tooltip-title {
    @apply text-xs text-neutral-text leading-tight;
}
.tooltip-value {
    @apply text-xl font-bold leading-tight;
}
.tooltip-label {
    @apply text-xs leading-tight;
}
.tooltip-compare-value {
    @apply text-2xs text-neutral-text;
}
</style>
